// File generated automatically, do not modify

import axios, { AxiosResponse } from 'axios';
import { Facility, Service, DoctorWithAddresses, Schedule, CalendarStateDto, IntegrationConfigurationDto } from './models';

const paths = {
  facilities: 'api/Docplanner/Facilities',
  services: 'api/Docplanner/Services',
  doctors: 'api/Docplanner/Doctors',
  schedule: 'api/Docplanner/Schedule',
  breaks: 'api/Docplanner/Breaks',
  calendarState: 'api/Docplanner/CalendarState',
  configuration: 'api/Docplanner/Configuration',
  heartbeat: 'api/Heartbeat',
};

function facilities(): Promise<Facility[]> {
  return axios.request<Facility[]>({
    url: paths.facilities,
    method: 'get',
  }).then(res => res.data);
}

function services(): Promise<Service[]> {
  return axios.request<Service[]>({
    url: paths.services,
    method: 'get',
  }).then(res => res.data);
}

interface DoctorsParams {
  facilityId?: string;
}

function doctors(params: DoctorsParams): Promise<DoctorWithAddresses[]> {
  return axios.request<DoctorWithAddresses[]>({
    url: paths.doctors,
    method: 'get',
    params,
  }).then(res => res.data);
}

interface ScheduleParams {
  facilityId?: string;
  doctorId?: string;
  addressId?: string;
  start?: string;
  end?: string;
}

function schedule(params: ScheduleParams): Promise<Schedule> {
  return axios.request<Schedule>({
    url: paths.schedule,
    method: 'get',
    params,
  }).then(res => res.data);
}

interface BreaksParams {
  facilityId?: string;
  doctorId?: string;
  addressId?: string;
}

function breaks(args: { params: BreaksParams; data: string[]; }): Promise<AxiosResponse<any>> {
  const { params, data } = args;
  return axios.request<any>({
    url: paths.breaks,
    method: 'delete',
    params,
    data,
  });
}

interface CalendarStateParams {
  facilityId?: string;
  doctorId?: string;
  addressId?: string;
  set?: boolean;
}

function calendarState(params: CalendarStateParams): Promise<CalendarStateDto> {
  return axios.request<CalendarStateDto>({
    url: paths.calendarState,
    method: 'post',
    params,
  }).then(res => res.data);
}

function configuration(): Promise<IntegrationConfigurationDto> {
  return axios.request<IntegrationConfigurationDto>({
    url: paths.configuration,
    method: 'get',
  }).then(res => res.data);
}

function heartbeat(): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.heartbeat,
    method: 'get',
  });
}

export const docplannerService = {
  paths,
  facilities,
  services,
  doctors,
  schedule,
  breaks,
  calendarState,
  configuration,
  heartbeat,
};
